import React, { useEffect, useState } from 'react'
import ContractManagementRepository from '../../api/repositories/contractManagementRepository';
import moment from 'moment';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomDatePicker from '../commoncomponents/CustomDatePicker';
import CustomTextArea from '../commoncomponents/CustomTextArea';
import { v4 as uuidv4 } from 'uuid';


const RenewalProcessStatusModal = ({ open, onClose, editMode, rows, setRows }) => {

    const initialState = {
        flag:"",
        pic:"",
        activity:"",
        dateAndTime:"",
        remarks:"",
        dummy_id:"",
        id:""
    };
    const [renewalProcess,setRenewalProcess] = useState(initialState);
    const [options,setOptions] = useState({
        flag:"",
        pic:"",
        activity:"",
    })

    const handleOnchange = (value,name)=>{
        setRenewalProcess((prev)=>({
            ...prev,
            [name]:value
        }));
    };

     const handleDateTimeAuto = (newDate) => {
            if (newDate) {
                let dayin = moment(newDate, 'DD/MM/YYYY', true);
                if (dayin.isValid()) {
                    let formattedDate = dayin.format('YYYY-MM-DD HH:mm:ss');
                    setRenewalProcess((prev) => ({
                        ...prev,
                        dateAndTime: formattedDate
                    }));
                };
            };
        };
        
        useEffect(() => {
            const getLov = async () => {
                try {
                    const flag = await ContractManagementRepository.fetchRenewalFlag();
                    const pic = await ContractManagementRepository.fetchRenewalPic();
                    const activity = await ContractManagementRepository.fetchRenewalActivity();
                    const getLovValues = await ContractManagementRepository.getAllLovValues();
                    
                    setOptions((prev)=>({
                        ...prev,
                        // flag:flag,
                        pic:pic,
                        // activity:activity
                    }));
                    
                    setOptions((prevOptions) => ({
                        ...prevOptions,
                        flag: getLovValues?.femcontractrenewalflags?.map((item) => (
                            {
                                key: `option${item?.id}`,
                                label: item?.renewalflagstatus || "",
                                id: item?.id || "",
                                value: item?.renewalflagstatus || ""
                            })),
                        activity:getLovValues?.femcontractrenewalactivities?.map((item) => (
                            {
                                key: `option${item?.id}`,
                                label: item?.renewalactivitystatus || "",
                                id: item?.id || "",
                                value: item?.renewalactivitystatus || ""
                            }))
                    }));

                    // if (contractType.length > 0) {
                    //     handleOnChange(contractType[0], "contractType");
                    // }
                        
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };
            getLov();
        }, []);        

        useEffect(()=>{
            if(editMode){
                setRenewalProcess({
                    flag:editMode?.flag || "",
                    pic:editMode?.pic || "",
                    activity:editMode?.activity || "",
                    dateAndTime:editMode?.dateAndTime || "",
                    remarks:editMode?.remarks || "",
                    dummy_id:editMode?.dummy_id || "",
                    id:editMode?.id || ""
                });
            } else {
                setRenewalProcess(initialState);
            };
        },[editMode]);        

        const formatDateForDisplay = (date) => {
            return moment(date).format('DD/MM/YYYY');
        };

         const handleSave = async (e) => {
           e.preventDefault();
       
           if (editMode?.dummy_id || editMode?.id) {
             if (editMode?.id) {
               // Update existing row
               const updatedRows = rows.map((row) =>
                 row.id === editMode?.id ? {...renewalProcess,dummy_id:row?.id} : row
               );               
               setRows(updatedRows);
             } else if (editMode?.dummy_id) {
               // Update existing row
               const updatedRows = rows.map((row) =>
                 row?.dummy_id === editMode?.dummy_id ? {...renewalProcess,id:row?.dummy_id} : row
               );
               setRows(updatedRows);
             };

            } else {
             // Add new row
             const newItem = {
               ...renewalProcess,
               dummy_id: uuidv4(),       
             };
             setRows((prev)=>[...prev,newItem]);
           }
           onClose();
           setRenewalProcess(initialState);
         };
       

        const handleCancel = () => {
            setRenewalProcess(initialState);
            onClose();
          };

  return (
    <>
      <Dialog
          open={open}
        >
          <DialogTitle>
            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>{editMode ? "Edit Renewal Process Status" : "Add Renewal Process Status"}</Typography>
          </DialogTitle>
           <DialogContent>
                  <Grid container spacing={2}>
                  <Grid item xs={6} md={6}>
                        <CustomSelectInput
                            label="Flag"
                            value={renewalProcess?.flag}
                            onChange={handleOnchange}
                            options={options?.flag || []}
                            id="flag"
                            name="flag"
                            modal={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomSelectInput
                            label="PIC"
                            value={renewalProcess?.pic}
                            onChange={handleOnchange}
                            options={options?.pic || []}
                            id="pic"
                            name="pic"
                            modal={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomSelectInput
                            label="Activity"
                            value={renewalProcess?.activity}
                            onChange={handleOnchange}
                            options={options?.activity || []}
                            id="activity"
                            name="activity"
                            modal={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomDatePicker
                            label="Date/Time"
                            id="date/time"
                            name="dateAndTime"
                            value={formatDateForDisplay(renewalProcess?.dateAndTime)}
                            onDateChange={handleDateTimeAuto}
                            modal={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomTextArea
                            label="Remarks"
                            id="remarks"
                            name="remarks"
                            value={renewalProcess?.remarks}
                            onChange={(e) => handleOnchange(e, "remarks")}
                            maxlength={180}
                            
                        />
                    </Grid>
                  </Grid>
                </DialogContent>
           <DialogActions>
                  <Button variant="contained" onClick={handleSave}>
                    {editMode ? "UPDATE" : "ADD"}
                  </Button>
                  <Button variant="outlined" onClick={handleCancel}>
                    CANCEL
                  </Button>
                </DialogActions>
          </Dialog>
      {/* <form onSubmit={handleSave} style={{ position: "relative" }}>
                    <Box mb={2}>
                        <Grid container gap={3}>
                            <Grid item xs={6} md={3.8}>
                                <CustomSelectInput
                                    label="Flag"
                                    value={renewalProcess?.flag}
                                    onChange={handleOnchange}
                                    options={options?.flag || []}
                                    id="flag"
                                    name="flag"
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomSelectInput
                                    label="PIC"
                                    value={renewalProcess?.pic}
                                    onChange={handleOnchange}
                                    options={options?.pic || []}
                                    id="pic"
                                    name="pic"
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomSelectInput
                                    label="Activity"
                                    value={renewalProcess?.activity}
                                    onChange={handleOnchange}
                                    options={options?.activity || []}
                                    id="activity"
                                    name="activity"
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomDatePicker
                                    label="Date/Time (Auto)"
                                    id="date/time"
                                    name="dateAndTime"
                                    value={formatDateForDisplay(renewalProcess?.dateAndTime)}
                                    onDateChange={handleDateTimeAuto}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextArea
                                    label="Remarks"
                                    id="remarks"
                                    name="remarks"
                                    value={renewalProcess?.remarks}
                                    onChange={(e) => handleOnchange(e, "remarks")}
                                    maxlength={180}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </form> */}
    </>
  )
}

export default RenewalProcessStatusModal
